import UserProfile from '../../base/pages/userProfile';

const userProfile: UserProfile = {
  requestFailed: "Profiländerung ist fehlgeschlagen."
};

export default userProfile;
